import { render, staticRenderFns } from "./registry-organization.html?vue&type=template&id=d3eb9e10&"
import script from "./RegistryOrganization.vue?vue&type=script&lang=js&"
export * from "./RegistryOrganization.vue?vue&type=script&lang=js&"
import style0 from "./RegistryOrganization.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports